export default "__VITE_ASSET__Dywu7e2g__"